<template>
  <nav class="flex flex-col justify-start gap-3 text-sm">
    <slot />
  </nav>
</template>
